import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$4, i as isPercentage } from './jw-player-base-injector-container.js';
import { d as defineCustomElement$6 } from './icon.js';
import { d as defineCustomElement$5 } from './jw-player-base-injector.js';
import { d as defineCustomElement$3 } from './jw-player-base-overlay.js';
import { d as defineCustomElement$2 } from './loader.js';

const jwPlayerBaseCss = ".wui-jw-player-base{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:inline-block;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;position:relative}.wui-jw-player-base *,.wui-jw-player-base :after,.wui-jw-player-base :before{box-sizing:inherit}.wui-jw-player-base img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.wui-jw-player-base__player-container{align-items:center;bottom:0;display:flex;height:100%;justify-content:center;left:0;position:absolute;right:0;top:0;width:100%;z-index:0}wui-jw-player-base-container,wui-jw-player-base-injector{display:flex;flex:1;height:100%;width:100%}";
const WuiJwPlayerBaseStyle0 = jwPlayerBaseCss;

function parseAspectRatio(aspectratio) {
    return aspectratio.split(':').map((s) => +s);
}
function calcAspectRatioPercentage(aspectratio) {
    const [width, height] = parseAspectRatio(aspectratio);
    return (1 / (width / height)) * 100;
}
function toPx(val) {
    if (typeof val === 'number') {
        return `${val}px`;
    }
    return val || '';
}
function getDimensions(playerOptions = {}) {
    const { width, height, aspectratio } = playerOptions;
    // Default values as defined by jwplayer
    const defaultWidth = '640px';
    const defaultHeight = '360px';
    let finalWidth;
    let finalHeight;
    if (aspectratio && isPercentage(width)) {
        finalWidth = width;
        // Ignore height
    }
    else {
        finalWidth = toPx(width) || defaultWidth;
        finalHeight = toPx(height) || defaultHeight;
    }
    return {
        width: finalWidth,
        height: finalHeight,
    };
}
function getAspectBoxStyle(playerOptions) {
    if (!playerOptions) {
        return;
    }
    const { aspectratio, width } = playerOptions;
    if (aspectratio && isPercentage(width)) {
        return { paddingTop: `${calcAspectRatioPercentage(aspectratio)}%` };
    }
}
const WuiJwPlayerBase$1 = /*@__PURE__*/ proxyCustomElement(class WuiJwPlayerBase extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.playerInstantiate = createEvent(this, "playerInstantiate", 7);
        this.playerSetup = createEvent(this, "playerSetup", 7);
        this.playerError = createEvent(this, "playerError", 7);
        this.playerReady = createEvent(this, "playerReady", 7);
        this.isContentOverlayHidden = () => {
            // If we can't render a player, don't hide the content overlay
            const canRenderPlayer = this.playerLicenseKey && this.playerVersion;
            if (!canRenderPlayer) {
                return false;
            }
            // One of these props means that we need to overlay something
            if (this.showOverlay || this.loading || this.error) {
                return false;
            }
            // Default to true
            return true;
        };
        this.playerOptions = undefined;
        this.playerVersion = undefined;
        this.playerLicenseKey = undefined;
        this.showOverlay = undefined;
        this.loading = undefined;
        this.error = undefined;
        this.errorLink = undefined;
    }
    render() {
        return (h(Host, { key: 'c76aa8d5ac2a669c85a61aaf2f1465a251483945', "data-error": Boolean(this.error), style: getDimensions(this.playerOptions), class: "wui-jw-player-base" }, h("div", { key: '3005652aebeef68568cefcf4ebe8b1ee1438498b', style: getAspectBoxStyle(this.playerOptions) }), h("div", { key: 'a9e886fd1125652bb2b22adb756d4840e9435bbe', class: "wui-jw-player-base__player-container" }, this.playerLicenseKey && this.playerVersion && (h("wui-jw-player-base-injector", { key: `${this.playerVersion}_${this.playerLicenseKey}`, playerLicenseKey: this.playerLicenseKey, playerVersion: this.playerVersion, playerOptions: this.playerOptions }))), h("wui-jw-player-base-overlay", { key: '925930b0f27e534892adeff7a52dbeffb44e1320', visible: !this.isContentOverlayHidden(), loading: !!this.loading, loadingText: this.loading && typeof this.loading === 'string' ? this.loading : undefined, error: this.error, errorLink: this.errorLink }, h("slot", { key: '1a5a7fe6cd3957c46b0bda3d6bd4714a93ba2532' }))));
    }
    static get style() { return WuiJwPlayerBaseStyle0; }
}, [4, "wui-jw-player-base", {
        "playerOptions": [16],
        "playerVersion": [1, "player-version"],
        "playerLicenseKey": [1, "player-license-key"],
        "showOverlay": [4, "show-overlay"],
        "loading": [520],
        "error": [16],
        "errorLink": [1, "error-link"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-jw-player-base", "wui-icon", "wui-jw-player-base-injector", "wui-jw-player-base-injector-container", "wui-jw-player-base-overlay", "wui-loader"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-jw-player-base":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiJwPlayerBase$1);
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-jw-player-base-injector":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-jw-player-base-injector-container":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-jw-player-base-overlay":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiJwPlayerBase = WuiJwPlayerBase$1;
const defineCustomElement = defineCustomElement$1;

export { WuiJwPlayerBase, defineCustomElement };

//# sourceMappingURL=wui-jw-player-base.js.map